var React = require('react');

function Up (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 5.5978L14.1454 11.6848C14.5697 12.1051 15.2576 12.1051 15.6818 11.6848C16.1061 11.2646 16.1061 10.5833 15.6818 10.1631L8.76818 3.31517C8.34393 2.89495 7.65607 2.89495 7.23182 3.31517L0.318191 10.1631C-0.106064 10.5833 -0.106064 11.2646 0.318191 11.6848C0.742445 12.1051 1.4303 12.1051 1.85455 11.6848L8 5.5978Z","fill":"currentColor"}));
}

Up.defaultProps = {"viewBox":"0 0 16 16","id":"up"};

module.exports = Up;

Up.default = Up;
